<template>
  <div class="ordenes-listado">

    <!-- Cabecera -->
    <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
      <h5 class="mb-0 fw-semibold" style="color:var(--text-primary)">
        <i class="bi bi-tools me-2" style="color:var(--primary-main)"></i>Ordenes de Taller
      </h5>
      <button v-if="puedeCrear" class="btn btn-sm btn-primary" @click="$router.push('/taller/ordenes/nuevo')">
        <i class="bi bi-plus-circle me-1"></i>Nueva Orden
      </button>
    </div>

    <!-- Filtros -->
    <div class="card shadow-sm mb-3" style="background:var(--secondary-bg-main);border:1px solid var(--border-main)">
      <div class="card-body py-2 px-3">
        <div class="row g-2 align-items-end">
          <div class="col-6 col-md-2">
            <label class="form-label small mb-1" style="color:var(--text-secondary)">Estado</label>
            <select class="form-select form-select-sm" v-model="filtros.estado" @change="aplicarFiltros"
                    style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
              <option value="">Todos</option>
              <option value="abierta">Abierta</option>
              <option value="en_proceso">En proceso</option>
              <option value="completada">Completada</option>
              <option value="cancelada">Cancelada</option>
              <option value="facturada">Facturada</option>
            </select>
          </div>
          <div class="col-6 col-md-3">
            <label class="form-label small mb-1" style="color:var(--text-secondary)">Buscar</label>
            <input type="text" class="form-control form-control-sm" v-model="filtros.busqueda"
                   @change="aplicarFiltros" @keyup.enter="aplicarFiltros"
                   placeholder="N° orden, propietario, placa..."
                   style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
          </div>
          <div class="col-6 col-md-2">
            <label class="form-label small mb-1" style="color:var(--text-secondary)">Desde</label>
            <input type="date" class="form-control form-control-sm" v-model="filtros.fecha_desde" @change="aplicarFiltros"
                   style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
          </div>
          <div class="col-6 col-md-2">
            <label class="form-label small mb-1" style="color:var(--text-secondary)">Hasta</label>
            <input type="date" class="form-control form-control-sm" v-model="filtros.fecha_hasta" @change="aplicarFiltros"
                   style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
          </div>
          <div class="col-12 col-md-3 d-flex gap-2">
            <button class="btn btn-sm btn-outline-secondary flex-fill" @click="limpiarFiltros">
              <i class="bi bi-x-circle me-1"></i>Limpiar
            </button>
            <button class="btn btn-sm btn-primary flex-fill" @click="aplicarFiltros" :disabled="cargando">
              <i class="bi bi-search me-1"></i>Buscar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Error -->
    <div v-if="errorMensaje" class="alert alert-danger d-flex align-items-center gap-2 mb-3 py-2">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <span>{{ errorMensaje }}</span>
      <button type="button" class="btn-close ms-auto" @click="errorMensaje = ''"></button>
    </div>

    <!-- Tabla -->
    <div class="card shadow-sm" style="background:var(--secondary-bg-main);border:1px solid var(--border-main)">
      <div class="card-body p-0">
        <div v-if="cargando" class="text-center py-5" style="color:var(--text-muted)">
          <div class="spinner-border spinner-border-sm me-2"></div>Cargando ordenes...
        </div>
        <div v-else-if="ordenes.length === 0" class="text-center py-5" style="color:var(--text-muted)">
          <i class="bi bi-inbox fs-2 d-block mb-2"></i>No hay ordenes para los filtros seleccionados.
        </div>
        <div v-else class="table-responsive">
          <table class="table table-sm table-hover mb-0">
            <thead style="background:var(--bg-main)">
              <tr style="color:var(--text-secondary);font-size:.78rem">
                <th class="ps-3">N° Orden</th>
                <th>Vehiculo</th>
                <th>Propietario / Cliente</th>
                <th>Fecha</th>
                <th class="text-end">Total</th>
                <th class="text-center">Estado</th>
                <th class="text-center pe-3">Acciones</th>
              </tr>
            </thead>
            <tbody style="font-size:.82rem">
              <tr v-for="o in ordenes" :key="o.id">
                <td class="ps-3 fw-semibold" style="color:var(--text-primary)">{{ o.numero_orden }}</td>
                <td style="color:var(--text-primary)">
                  {{ o.marca }} {{ o.modelo }}
                  <div v-if="o.placa" class="text-muted" style="font-size:.72rem">Placa: {{ o.placa }}</div>
                </td>
                <td style="color:var(--text-secondary)">{{ o.cliente_nombre || o.propietario_nombre || '—' }}</td>
                <td style="color:var(--text-secondary)">{{ formatearFecha(o.created_at) }}</td>
                <td class="text-end fw-semibold" style="color:var(--accent-success)">{{ dinero(o.total) }}</td>
                <td class="text-center">
                  <span class="badge" :class="badgeEstado(o.estado)">{{ labelEstado(o.estado) }}</span>
                </td>
                <td class="text-center pe-3">
                  <div class="d-flex gap-1 justify-content-center">
                    <button class="btn btn-xs btn-outline-primary" title="Ver detalle" @click="$router.push('/taller/ordenes/' + o.id)">
                      <i class="bi bi-eye"></i>
                    </button>
                    <button
                      v-if="puedeEditar && (o.estado === 'abierta' || o.estado === 'en_proceso')"
                      class="btn btn-xs btn-outline-warning"
                      title="Editar orden"
                      @click="$router.push('/taller/ordenes/' + o.id + '/editar')">
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button
                      v-if="puedeEditar && o.estado !== 'cancelada' && o.estado !== 'facturada'"
                      class="btn btn-xs btn-outline-secondary"
                      title="Cambiar estado"
                      @click="abrirModalEstado(o)">
                      <i class="bi bi-arrow-left-right"></i>
                    </button>
                    <button
                      v-if="puedeEditar && o.estado !== 'cancelada' && o.estado !== 'facturada'"
                      class="btn btn-xs btn-success"
                      title="Convertir a factura"
                      @click="iniciarConversion(o)">
                      <i class="bi bi-receipt-cutoff me-1"></i>Facturar
                    </button>
                    <span v-if="o.estado === 'facturada'" class="text-success small">
                      <i class="bi bi-check-circle-fill me-1"></i>Facturada
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          v-if="!cargando && paginacion.total > 0"
          class="paginacion-taller d-flex flex-column flex-sm-row align-items-center justify-content-between gap-2 px-3 py-2"
        >
          <span class="small" style="color:var(--text-secondary)">
            Mostrando {{ registroDesde }}–{{ registroHasta }} de {{ paginacion.total }} órdenes
          </span>
          <nav v-if="paginacion.totalPaginas > 1" aria-label="Paginación de órdenes de taller">
            <div class="d-flex align-items-center gap-1">
              <button
                type="button"
                class="btn-pagina-taller"
                title="Primera página"
                aria-label="Primera página"
                :disabled="paginacion.pagina === 1"
                @click="irPagina(1)"
              ><i class="bi bi-chevron-double-left"></i></button>
              <button
                type="button"
                class="btn-pagina-taller"
                title="Página anterior"
                aria-label="Página anterior"
                :disabled="paginacion.pagina === 1"
                @click="irPagina(paginacion.pagina - 1)"
              ><i class="bi bi-chevron-left"></i></button>
              <span class="pagina-actual-taller" aria-live="polite">
                Página {{ paginacion.pagina }} de {{ paginacion.totalPaginas }}
              </span>
              <button
                type="button"
                class="btn-pagina-taller"
                title="Página siguiente"
                aria-label="Página siguiente"
                :disabled="paginacion.pagina >= paginacion.totalPaginas"
                @click="irPagina(paginacion.pagina + 1)"
              ><i class="bi bi-chevron-right"></i></button>
              <button
                type="button"
                class="btn-pagina-taller"
                title="Última página"
                aria-label="Última página"
                :disabled="paginacion.pagina >= paginacion.totalPaginas"
                @click="irPagina(paginacion.totalPaginas)"
              ><i class="bi bi-chevron-double-right"></i></button>
            </div>
          </nav>
        </div>
      </div>
    </div>

    <!-- ── Modal: Cambiar estado ── -->
    <div v-if="modalEstado.visible" class="modal-overlay" @click.self="modalEstado.visible = false">
      <div class="modal-caja" style="max-width:420px">
        <div class="modal-header-caja d-flex align-items-center justify-content-between">
          <span class="fw-semibold" style="color:var(--text-primary)">
            <i class="bi bi-arrow-left-right me-2" style="color:var(--primary-main)"></i>Cambiar Estado
          </span>
          <button class="btn-close-caja" @click="modalEstado.visible = false">✕</button>
        </div>
        <div class="modal-body-caja">
          <p class="small mb-2" style="color:var(--text-secondary)">
            Orden: <strong style="color:var(--text-primary)">{{ modalEstado.orden && modalEstado.orden.numero_orden }}</strong>
          </p>
          <div v-if="modalEstado.nuevoEstado === 'cancelada'" class="alert alert-warning py-2 small mb-3">
            <i class="bi bi-exclamation-triangle me-1"></i>
            Al cancelar, los repuestos ya cargados se devuelven al inventario.
          </div>
          <div class="mb-3">
            <label class="form-label small" style="color:var(--text-secondary)">Nuevo estado</label>
            <select class="form-select form-select-sm" v-model="modalEstado.nuevoEstado"
                    style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
              <option value="abierta">Abierta</option>
              <option value="en_proceso">En proceso</option>
              <option value="completada">Completada</option>
              <option value="cancelada">Cancelada</option>
            </select>
          </div>
          <div v-if="modalEstado.nuevoEstado === 'cancelada'" class="mb-3">
            <label class="form-label small" style="color:var(--text-secondary)">Motivo de cancelación</label>
            <input type="text" class="form-control form-control-sm" v-model="modalEstado.motivo"
                   placeholder="Opcional"
                   style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
          </div>
        </div>
        <div class="modal-footer-caja d-flex gap-2 justify-content-end">
          <button class="btn btn-outline-secondary btn-sm" @click="modalEstado.visible = false">Cancelar</button>
          <button class="btn btn-primary btn-sm" @click="ejecutarCambioEstado" :disabled="modalEstado.guardando">
            <span v-if="modalEstado.guardando" class="spinner-border spinner-border-sm me-1"></span>
            Guardar
          </button>
        </div>
      </div>
    </div>

    <!-- ── Modal: Confirmar conversión a factura ── -->
    <div v-if="modalConversion.visible" class="modal-overlay" @click.self="modalConversion.visible = false">
      <div class="modal-caja" style="max-width:440px">
        <div class="modal-header-caja d-flex align-items-center justify-content-between">
          <span class="fw-semibold" style="color:var(--text-primary)">
            <i class="bi bi-receipt-cutoff me-2" style="color:var(--accent-success)"></i>Convertir a Factura
          </span>
          <button class="btn-close-caja" @click="modalConversion.visible = false">✕</button>
        </div>
        <div class="modal-body-caja">
          <div class="alert alert-info py-2 small">
            <i class="bi bi-info-circle me-1"></i>
            Se pre-cargarán los datos de la orden <strong>{{ modalConversion.orden && modalConversion.orden.numero_orden }}</strong>
            en el formulario de facturación. Revise y emita la factura desde allí.
          </div>
          <div v-if="modalConversion.cargando" class="text-center py-3" style="color:var(--text-muted)">
            <div class="spinner-border spinner-border-sm me-2"></div>Preparando datos...
          </div>
          <div v-if="modalConversion.error" class="alert alert-danger py-2 small">{{ modalConversion.error }}</div>
        </div>
        <div class="modal-footer-caja d-flex gap-2 justify-content-end">
          <button class="btn btn-outline-secondary btn-sm" @click="modalConversion.visible = false" :disabled="modalConversion.cargando">Cancelar</button>
          <button class="btn btn-success btn-sm" @click="ejecutarConversion" :disabled="modalConversion.cargando">
            <span v-if="modalConversion.cargando" class="spinner-border spinner-border-sm me-1"></span>
            <i v-else class="bi bi-arrow-right-circle me-1"></i>Ir a Facturación
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { ordenTallerService } from '@/services/ordenTallerService'
import notificaciones from '@/services/notificationService.js'

export default {
  name: 'ClientTallerOrdenes',

  computed: {
    puedeCrear() {
      return this.$store.getters.puedoHacer('/taller/ordenes', 'crear')
    },
    puedeEditar() {
      return this.$store.getters.puedoHacer('/taller/ordenes', 'editar')
    },
    registroDesde() {
      if (this.paginacion.total === 0) return 0
      return ((this.paginacion.pagina - 1) * this.paginacion.limite) + 1
    },
    registroHasta() {
      return Math.min(this.paginacion.pagina * this.paginacion.limite, this.paginacion.total)
    }
  },

  data() {
    return {
      ordenes:      [],
      cargando:     false,
      errorMensaje: '',
      solicitudActual: 0,

      paginacion: {
        pagina:       1,
        limite:       20,
        total:        0,
        totalPaginas: 1
      },

      filtros: {
        estado:      '',
        busqueda:    '',
        fecha_desde: '',
        fecha_hasta: ''
      },

      modalEstado: {
        visible:    false,
        orden:      null,
        nuevoEstado:'',
        motivo:     '',
        guardando:  false
      },

      modalConversion: {
        visible:  false,
        orden:    null,
        cargando: false,
        error:    ''
      }
    }
  },

  mounted() {
    this.cargarOrdenes()
  },

  methods: {
    async cargarOrdenes() {
      const solicitudId = ++this.solicitudActual
      this.cargando     = true
      this.errorMensaje = ''
      try {
        const filtrosActivos = Object.fromEntries(
          Object.entries(this.filtros).filter(([, v]) => v !== '')
        )
        const res = await ordenTallerService.listar({
          ...filtrosActivos,
          page:  this.paginacion.pagina,
          limit: this.paginacion.limite
        })
        if (solicitudId !== this.solicitudActual) return

        const datos = res.data.data || {}
        this.ordenes                  = datos.ordenes || []
        this.paginacion.total         = Number(datos.total || 0)
        this.paginacion.totalPaginas  = Math.max(1, Number(datos.total_pages || 1))
        this.paginacion.limite        = Number(datos.limite || this.paginacion.limite)

        const paginaServidor = Number(datos.pagina || this.paginacion.pagina)
        this.paginacion.pagina = Math.min(
          Math.max(1, paginaServidor),
          this.paginacion.totalPaginas
        )
      } catch {
        if (solicitudId !== this.solicitudActual) return
        this.errorMensaje = 'Error al cargar las ordenes.'
        this.ordenes = []
        this.paginacion.total = 0
        this.paginacion.totalPaginas = 1
      } finally {
        if (solicitudId === this.solicitudActual) this.cargando = false
      }
    },

    aplicarFiltros() {
      this.paginacion.pagina = 1
      this.cargarOrdenes()
    },

    limpiarFiltros() {
      this.filtros = { estado: '', busqueda: '', fecha_desde: '', fecha_hasta: '' }
      this.paginacion.pagina = 1
      this.cargarOrdenes()
    },

    irPagina(pagina) {
      const destino = Number(pagina)
      if (
        this.cargando ||
        destino < 1 ||
        destino > this.paginacion.totalPaginas ||
        destino === this.paginacion.pagina
      ) return

      this.paginacion.pagina = destino
      this.cargarOrdenes()
    },

    abrirModalEstado(orden) {
      this.modalEstado.orden       = orden
      this.modalEstado.nuevoEstado = orden.estado
      this.modalEstado.motivo      = ''
      this.modalEstado.guardando   = false
      this.modalEstado.visible     = true
    },

    async ejecutarCambioEstado() {
      this.modalEstado.guardando = true
      try {
        await ordenTallerService.cambiarEstado(
          this.modalEstado.orden.id,
          this.modalEstado.nuevoEstado,
          this.modalEstado.motivo || null
        )
        notificaciones.success('Estado actualizado a "' + this.labelEstado(this.modalEstado.nuevoEstado) + '".')
        this.modalEstado.visible = false
        this.cargarOrdenes()
      } catch (e) {
        notificaciones.error((e?.response?.data?.error) || 'Error al cambiar el estado.')
      } finally {
        this.modalEstado.guardando = false
      }
    },

    iniciarConversion(orden) {
      this.modalConversion.orden    = orden
      this.modalConversion.cargando = false
      this.modalConversion.error    = ''
      this.modalConversion.visible  = true
    },

    async ejecutarConversion() {
      this.modalConversion.cargando = true
      this.modalConversion.error    = ''
      try {
        const res   = await ordenTallerService.convertir(this.modalConversion.orden.id)
        const datos = res.data.data
        this.modalConversion.visible = false
        sessionStorage.setItem('orden_taller_prefill', JSON.stringify(datos))
        this.$router.push('/ventas/facturacion')
      } catch (e) {
        this.modalConversion.error = (e?.response?.data?.error) || 'Error al obtener los datos de la orden.'
      } finally {
        this.modalConversion.cargando = false
      }
    },

    // ── Helpers ──────────────────────────────────────────────
    dinero(valor) {
      return '$ ' + parseFloat(valor || 0).toFixed(2)
    },

    formatearFecha(fecha) {
      if (!fecha) return '-'
      return new Date(fecha).toLocaleDateString('es-EC', {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit'
      })
    },

    labelEstado(estado) {
      const mapa = {
        abierta:    'Abierta',
        en_proceso: 'En proceso',
        completada: 'Completada',
        cancelada:  'Cancelada',
        facturada:  'Facturada'
      }
      return mapa[estado] || estado
    },

    badgeEstado(estado) {
      const mapa = {
        abierta:    'bg-secondary',
        en_proceso: 'bg-warning text-dark',
        completada: 'bg-info text-dark',
        cancelada:  'bg-danger',
        facturada:  'bg-success'
      }
      return mapa[estado] || 'bg-secondary'
    }
  }
}
</script>

<style scoped>
.ordenes-listado {
  padding: 1.25rem;
  color: var(--text-primary);
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.modal-caja {
  background: var(--secondary-bg-main);
  border: 1px solid var(--border-main);
  border-radius: .5rem;
  width: 100%;
  box-shadow: var(--shadow-md);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
}

.modal-header-caja {
  padding: .75rem 1rem;
  border-bottom: 1px solid var(--border-main);
  flex-shrink: 0;
}

.modal-body-caja {
  padding: 1rem;
  overflow-y: auto;
  flex: 1;
}

.modal-footer-caja {
  padding: .75rem 1rem;
  border-top: 1px solid var(--border-main);
  flex-shrink: 0;
}

.btn-close-caja {
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  color: var(--text-muted);
  line-height: 1;
  padding: 0;
}
.btn-close-caja:hover {
  color: var(--accent-danger);
}

.btn-xs {
  padding: .15rem .4rem;
  font-size: .75rem;
}

.paginacion-taller {
  border-top: 1px solid var(--border-main);
  background: var(--secondary-bg-main);
}

.btn-pagina-taller,
.pagina-actual-taller {
  min-height: 2rem;
  border: 1px solid var(--border-main);
  border-radius: .35rem;
  background: var(--bg-main);
  color: var(--text-primary);
  font-size: .78rem;
}

.btn-pagina-taller {
  min-width: 2rem;
  padding: .25rem .45rem;
}

.btn-pagina-taller:not(:disabled):hover,
.btn-pagina-taller:not(:disabled):focus-visible {
  border-color: var(--border-focus);
  color: var(--primary-main);
  outline: none;
}

.btn-pagina-taller:disabled {
  color: var(--text-muted);
  cursor: not-allowed;
  opacity: .6;
}

.pagina-actual-taller {
  display: inline-flex;
  align-items: center;
  padding: .25rem .65rem;
  white-space: nowrap;
}
</style>
